import React, { PureComponent } from 'react';
import { I } from '../../../../common/v5/config';
import { SerialMultiSelect , SingleSelectDD } from '../../../../reactcomponents/Dropdown';
import HelpTooltip from './HelpTooltip';
import './AgentForm.css';
import { OBJ_ID_NAME } from '../../../../common/v5/constants';

const toAreaIds = (arr) =>
  (arr || [])
    .map((id) => (typeof id === 'number' ? id : parseInt(id, 10)))
    .filter((n) => !isNaN(n));

// Areas: (1) form/modal state from parent, (2) API list shape (area_ids). No single-area fallback; list is normalized in loadAgents.
function getAreasFromAgent(agent) {
  if (!agent) return [];
  if (agent.areas != null && Array.isArray(agent.areas)) return toAreaIds(agent.areas);
  if (agent.area_ids != null && Array.isArray(agent.area_ids)) return toAreaIds(agent.area_ids);
  return [];
}

class AgentForm extends PureComponent {
  constructor(props) {
    super(props);

    // Initialize state with agent data if editing
    const { agent } = props;
    const areas = getAreasFromAgent(agent);
    console.log('[AgentForm:Areas] constructor', { agentId: agent?.agent_id ?? agent?.id, areas, agentAreaIds: agent?.area_ids, agentAreaId: agent?.area_id });

    this.state = {
      formData: {
        name: agent?.name || agent?.title || '',
        description: agent?.description || '',
        agent_type: this.mapAgentTypeFromAPI(agent?.agent_type || agent?.type) || 'AUTO_ANSWER',
        areas: areas,
        user_id: agent?.user_id || '',
        parentAgentId: agent?.parent_agent_id || agent?.parentAgentId || '',
        showUser: false
      },
      showAreasDropdown: false
    };

    // Bind methods
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleAreasSelect = this.handleAreasSelect.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleSelectUser = this.handleSelectUser.bind(this);
    this.handleToggleUser = this.handleToggleUser.bind(this);
  }

  // Map API agent types to UI format
  mapAgentTypeFromAPI(apiType) {
    switch (apiType) {
      case 'router':
        return 'ROUTER';
      case 'auto-answer':
        return 'AUTO_ANSWER';
      case 'chat':
        return 'CHAT';
      case 'team-member':
        return 'TEAM_MEMBER';
      case 'supervisor':
        return 'SUPERVISOR';
      case 'agent-assist':
        return 'AGENT_ASSIST';
      default:
        return 'AUTO_ANSWER';
    }
  }

  componentDidUpdate(prevProps) {
    // Update form data when agent prop changes
    if (prevProps.agent !== this.props.agent) {
      const { agent } = this.props;
      const areas = getAreasFromAgent(agent);
      const formData = {
        name: agent?.name || agent?.agent_name || agent?.title || '',
        description: agent?.description || '',
        agent_type: this.mapAgentTypeFromAPI(agent?.agent_type || agent?.type) || '',
        areas: areas,
        user_id: agent?.user_id || '',
        parentAgentId: agent?.parent_agent_id || agent?.parentAgentId || ''
      };
      console.log('[AgentForm:Areas] componentDidUpdate agent changed', { areas, formDataAreas: formData.areas });
      this.setState({ formData });
    }
  }

  // Notify parent of changes
  notifyChange() {
    const { onChange } = this.props;
    if (onChange) {
      const { formData } = this.state;
      onChange(formData);
    }
  }

  handleInputChange(field, value) {
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [field]: value
      }
    }), () => {
      this.notifyChange();
    });
  }

  // SerialMultiSelect onSelect passes comma-separated string; normalize to array of numbers and dedupe
  handleAreasSelect(selectedStr) {
    console.log('[AgentForm:Areas] handleAreasSelect called', { selectedStr, type: typeof selectedStr });
    const ids = (selectedStr == null || selectedStr === '' ? [] : String(selectedStr).split(','))
      .map((s) => parseInt(s.trim(), 10))
      .filter((n) => !isNaN(n));
    const deduped = [...new Set(ids)];
    console.log('[AgentForm:Areas] handleAreasSelect parsed', { ids, deduped });
    this.handleInputChange('areas', deduped);
  }

  handleSelectUser(userId) {
    this.handleInputChange('user_id', userId);
  }

  handleToggleUser() {
    this.setState(prevState => ({
      showUser: !prevState.showUser
    }));
  }

  handleTypeChange(e) {
    const newType = e.target.value;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        agent_type: newType,
        // Clear parent agent if router is selected (router agents cannot have parents)
        parentAgentId: newType === 'ROUTER' ? '' : prevState.formData.parentAgentId
      }
    }), () => {
      this.notifyChange();
    });
  }

  render() {
    const { areaList = [], agent } = this.props;
    const { formData } = this.state;
    const areasArray = Array.isArray(formData.areas) ? formData.areas : [];
    const selectedStr = areasArray.length > 0 ? areasArray.join(',') : '';
    const dataArray = Array.isArray(areaList) ? areaList : [];
    if (this.state.showAreasDropdown || areasArray.length > 0) {
      console.log('[AgentForm:Areas] render', {
        areaListIsArray: Array.isArray(areaList),
        areaListLength: dataArray.length,
        formDataAreas: formData.areas,
        selectedStr,
        showDropdown: this.state.showAreasDropdown
      });
    }
    // Only disable name when editing an existing agent (non-zero id). Create New Agent has id: 0.
    const isEditing = !!(
      agent &&
      ((agent.id != null && agent.id !== 0 && agent.id !== '0') ||
        (agent.agent_id != null && agent.agent_id !== 0 && agent.agent_id !== '0'))
    );

    return (
      <div className="admin-one-form custom">
        <div className="agent-manager">
          {/* Agent Name */}
          <div className="form-input-with-label-row">
            <div className="form-label mandatory">
              {I("Agent Name")}
            </div>
            <div className="form-input-container">
              <input
                type="text"
                id="agentName"
                name="agentName"
                value={formData.name}
                onChange={(e) => this.handleInputChange('name', e.target.value)}
                className="admin-text-input"
                placeholder={I("Enter agent name")}
                disabled={isEditing}
                style={isEditing ? { backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' } : {}}
              />
            </div>
          </div>

          {/* Agent Description */}
          <div className="form-input-with-label-row">
            <div className="form-label mandatory">
              {I("Agent Description")}
            </div>
            <div className="form-input-container">
              <textarea
                id="agentDescription"
                name="agentDescription"
                value={formData.description}
                onChange={(e) => this.handleInputChange('description', e.target.value)}
                className="admin-text-input"
                rows={4}
                placeholder={I("Enter agent description")}
              />
            </div>
          </div>

          {/* Agent Type */}
          <div className="form-input-with-label-row">
            <div className="form-label mandatory">
              {I("Agent Type")}
              <HelpTooltip
                content={`<strong>${I("Default:")}</strong> ${I("Standard agent type")}<br/><strong>${I("Router:")}</strong> ${I("Routes conversations to appropriate agents")}`}
                position="top"
              />
            </div>
            <div className="form-input-container">
              <select
                id="agentType"
                value={formData.agent_type}
                onChange={this.handleTypeChange}
                className="form-control styled-select"
              >
                <option value="">{I('Default')}</option>
                <option value="ROUTER">{I('Router')}</option>
              </select>
            </div>
          </div>

          {/* Areas (multi-select) */}
          <div className="form-input-with-label-row">
            <div className="form-label mandatory">
              {I("Areas")}
              <HelpTooltip
                content={I("Select one or more areas this agent belongs to. This determines access permissions and routing rules.")}
                position="top"
              />
            </div>
            <div className="form-input-container">
              <SerialMultiSelect
                id="agent-areas"
                flip={false}
                title={I('Select area(s)...')}
                className="popup-multi-select admin-text-input-qrm"
                overrideTitle={true}
                multiSelect={true}
                groupSelect={true}
                nested={{ key: 'Areas' }}
                data={dataArray}
                idFields={OBJ_ID_NAME}
                selected={selectedStr}
                onSelect={this.handleAreasSelect}
                onToggle={() => {
                  const next = !this.state.showAreasDropdown;
                  console.log('[AgentForm:Areas] onToggle', { next, currentAreas: formData.areas });
                  this.setState((s) => ({ showAreasDropdown: !s.showAreasDropdown }));
                }}
                show={this.state.showAreasDropdown}
                selectAll={true}
                selectNone={true}
                enableSearch={true}
              />
            </div>
          </div>

          {/* Parent Agent Selection */}
          <div className="form-input-with-label-row">
            <div className="form-label">
              {I("Parent Agent")} <span className="optional-text">({I("Optional")})</span>
              <HelpTooltip
                content={formData.agent_type === 'ROUTER'
                  ? I("Router agents cannot have a parent. They must be at the top level of the hierarchy.")
                  : I("Select a parent agent to create a hierarchical structure. Leave empty for root agents.")
                }
                position="top"
              />
            </div>
            <div className="form-input-container">
              <select
                id="parentAgent"
                value={formData.parentAgentId || ''}
                onChange={(e) => this.handleInputChange('parentAgentId', e.target.value)}
                className="form-control styled-select"
                disabled={formData.agent_type === 'ROUTER'}
              >
                <option value="">{I('No parent (root agent)')}</option>
                {this.props.agents && this.props.agents.filter(agent =>
                  // Don't allow self-reference when editing
                  !this.props.agent || (agent.id || agent.agent_id) !== (this.props.agent.id || this.props.agent.agent_id)
                ).map((agent) => (
                  <option key={agent.id || agent.agent_id} value={agent.agent_id || agent.id}>
                    {agent.name || agent.title || agent.agent_name || agent.agent_id} - {agent.description}
                  </option>
                ))}
              </select>
              {formData.agent_type === 'ROUTER' && (
                <div className="form-help-text" style={{ marginTop: '5px', fontSize: '12px', color: '#666' }}>
                  {I('Router agents are automatically set as root agents (no parent).')}
                </div>
              )}
            </div>
          </div>

          {/* User ID */}
          <div className="form-input-with-label-row">
            <div className="form-label">
              {I("User ID")}
              <HelpTooltip
                content={I("Specify the user ID linked to this agent.")}
                position="top"
              />
            </div>
            <div className="form-input-container">
              <SingleSelectDD
                id={"user_id"}
                className="popup-multi-select"
                overrideTitle={true}
                groupSelect={false}
                data={this.props.agentList}
                idFields={OBJ_ID_NAME}
                selected={formData.user_id}
                onSelect={this.handleSelectUser}
                onToggle={this.handleToggleUser}
                show={this.state.showUser}
                selectAll={false}
                selectNone={false}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AgentForm;